import PropTypes from 'prop-types';

import { SavingsContainer, SavingsNumbers, TextPink } from './styles';
import { connectLocation } from '../../location/LocationConnectors';

const Savings = connectLocation(({ results, t }) => {
  const { savings, projectSqFoot } = results;
  const { total = 0, bagsInsulationRequired } = savings;

  return (
    <SavingsContainer>
      <p>
        {t('insulation.commercial.quietzone.savings.based_on_your')}{' '}
        <TextPink>
          {projectSqFoot} {t('insulation.commercial.quietzone.savings.metric')}
        </TextPink>{' '}
        {t('insulation.commercial.quietzone.savings.and_location')}:
      </p>
      <SavingsNumbers>
        <div>
          <p>
            <TextPink>{bagsInsulationRequired}</TextPink>
          </p>
          <p>{t('insulation.commercial.quietzone.savings.bags_insulation')}</p>
        </div>
        <div>
          <p>
            <TextPink>${total}</TextPink>
          </p>
          <p>{t('insulation.commercial.quietzone.savings.total_savings')}</p>
        </div>
      </SavingsNumbers>
    </SavingsContainer>
  );
});

Savings.propTypes = {
  results: PropTypes.shape({
    projectSqFoot: PropTypes.string,
    savings: PropTypes.shape({
      bagsInsulationRequired: PropTypes.number.isRequired,
      total: PropTypes.number,
    }).isRequired,
  }),
};

Savings.defaultProps = {
  results: {
    projectSqFoot: '',
    savings: {
      total: 0,
      bagsInsulationRequired: 0,
    },
  },
};

export default Savings;
